const type = 'SET_NEW_CARD_SUBMITTING';

const setNewCardSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setNewCardSubmitting;
